import { useRouter } from 'next/router';
import useSWR from 'swr';
import DropDown, { DropDownOption } from 'components/common/DropDown';
import { formatDate } from 'lib/dateUtils';
import { jsonFetcherWithHandler as fetcher } from 'lib/swr';
import { CommunityPost, CommunityShotItem } from 'types/community';
import styles from './RevisionSelect.module.css';
import { getCommunityPath } from 'lib/community';

type Props = {
  shotItem: CommunityShotItem;
};

export default function RevisionSelect({ shotItem }: Props) {
  const router = useRouter();
  const { data: fetchedShotItem } = useSWR(
    `/api/community-posts/${shotItem.communityPostId}`,
    fetcher(shotItemHandler),
    { fallbackData: shotItem }
  );
  const revisions = fetchedShotItem!.revisions;
  const currentRevisionId = shotItem.communityRevisionId;

  function onSelect(revisionId: string) {
    const revision = revisions.find(
      (r) => r.communityRevisionId === parseInt(revisionId, 10)
    );
    const { slug } = revision!;
    const url = getCommunityPath(slug);
    router.push(url, undefined, { shallow: false });
  }

  const options = revisions.map((revision, i) => {
    const n = revisions.length - i;
    const updated = new Date(revision.lastUpdated);
    const revisionId = revision.communityRevisionId.toString();

    return (
      <DropDownOption
        value={revisionId}
        key={revisionId}
        selected={revisionId === currentRevisionId.toString()}
      >
        <div className={styles.Option}>
          <div className={styles.Date}>{formatDate(updated)}</div>
          <div className={styles.Version}>{`v${n}`}</div>
        </div>
      </DropDownOption>
    );
  });

  return (
    <DropDown
      optionKey={currentRevisionId.toString()}
      displayValue={formatDate(new Date(shotItem.lastUpdated))}
      displayValueStyle={{ color: '#f1f1f1' }}
      onSelect={(revision) => onSelect(revision as string)}
    >
      {options}
    </DropDown>
  );
}

function shotItemHandler(data: any) {
  return CommunityPost.fromAPI(data).toCommunityShotItem();
}
